module.exports = __webpack_public_path__ + "img/illu_devices.24afea4a.svg";